var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNav)?_c('top-nav'):_vm._e(),_c('div',{staticClass:"app-main"},[_c('router-view')],1),(_vm.showFooter)?_c('site-footer'):_vm._e(),_c('wechat-float')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }